import { SelectOption } from '@kanda-libs/ks-component-ts';
import { EmploymentDetails } from '@kanda-libs/ks-frontend-services';

type WidgetTagName =
  | 'CreditEmploymentDetailsEmployedDetailsMonthsEmployed'
  | 'CreditEmploymentDetailsSelfEmployedDetailsMonthsSelfEmployed'
  | 'CreditEmploymentDetailsNotEmployedDetailsMonthsNotEmployed'
  | 'CreditEmploymentDetailsRetiredDetailsMonthsRetired';

type CapitalisedFieldName =
  | 'EmployedDetailsMonthsEmployed'
  | 'SelfEmployedDetailsMonthsSelfEmployed'
  | 'NotEmployedDetailsMonthsNotEmployed'
  | 'RetiredDetailsMonthsRetired';

export type FieldName =
  | 'employed'
  | 'self_employed'
  | 'not_employed'
  | 'retired';

// DEV_NOTE: Would be good to try and find a better solution than this - using the
// capitalise function we have doesn't work
export const getMonthsFieldName = (status: FieldName): CapitalisedFieldName => {
  if (status === 'employed') return 'EmployedDetailsMonthsEmployed';
  if (status === 'self_employed')
    return 'SelfEmployedDetailsMonthsSelfEmployed';
  if (status === 'not_employed') return 'NotEmployedDetailsMonthsNotEmployed';
  return 'RetiredDetailsMonthsRetired';
};

// Takes a field name and index and returns the relevant Widget subcomponent
// name for an address field. For example:
// name=addressPostCode & index=0 => 'LeadApplicantCustomerDetailsCurrentAddressPostcode'
// name=addressPostCode & index=1 => 'LeadApplicantCustomerDetailsPreviousAddressOnePostcode'
export const getFieldWidgetTag = (
  status: EmploymentDetails['employment_status'],
): WidgetTagName => {
  const prefix = 'CreditEmploymentDetails';
  const formattedName = getMonthsFieldName(status);
  return `${prefix}${formattedName}`;
};

export const generateYearsOptions = (): SelectOption[] => {
  const now = new Date();
  const year = now.getFullYear();
  return Array.from(Array(100).keys(), (value: number) => ({
    name: `${year - value}`,
    value: `${year - value}`,
  })) as SelectOption[];
};

export const getTime = (years?: string, months?: string): number => {
  if (!years || !months) return -1;
  const now = new Date();
  const monthsDiff = now.getMonth() - parseInt(months, 10);
  const yearsDiff = now.getFullYear() - parseInt(years, 10);
  return yearsDiff * 12 + monthsDiff;
};
